<template>
  <div class="container col-lg-8 col-sm-12">
    <InterviewList />
  </div>
</template>

<script>
import InterviewList from "@/views/bookings/BookingInterviews/components/InterviewList";

export default {
  title: "Interviews - Track",
  name: "Interviews",
  components: {
    InterviewList
  }
};
</script>

<style lang="scss"></style>
